module.exports = __webpack_public_path__ + "media/images/icons/instagram-black-1834f835ac47cf0170e70192d78ef6b2.svg";